module.exports = __webpack_public_path__ + "static/media/icon-colector.d66ce72c.svg";